export default {"src":"/_next/static/media/icon_21.4283935e.svg","height":48,"width":48};